import {
  // PARSE_AUTH,
  AUTH_OK,
  USER_LOGGEDIN,
  USER_LOGOUT,
  API_AUTHORIZED,
  API_UNAUTHORIZED,
} from '../types';

const defaultState = {
  auth: {
    isLoggedIn: false,
    unauthorized: false,
  },
};

const auth = (state = defaultState.auth, action) => {
  switch (action.type) {
    case API_AUTHORIZED:
      return Object.assign({}, state, {
        unauthorized: false,
      });

    case API_UNAUTHORIZED:
      return Object.assign({}, state, {
        unauthorized: true,
      });

    case USER_LOGGEDIN:
      return Object.assign({}, state, {
        isLoggedIn: true,
      });

    // case PARSE_AUTH:
    //   return Object.assign({}, state, {
    //     token: action.token,
    //   });

    case AUTH_OK:
      return Object.assign({}, state, {
        isLoggedIn: action.isLoggedIn,
      });

    case USER_LOGOUT:
      return Object.assign({}, defaultState.auth);

    default:
      return state;
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/state/reducers/auth.js